import { STORYBLOK_TYPES } from '~/lib/storyblok-types'

export const PAGES_WITHOUT_FOOTER_BREADCRUMB = [
  STORYBLOK_TYPES.HOMEPAGE,
  STORYBLOK_TYPES.PRODUCT,
]
